import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { DeliveryInputDto, DeliveryService } from 'src/generated_client';

@Component({
  selector: 'app-add-person',
  templateUrl: './add-person.component.html',
  styleUrls: ['./add-person.component.css']
})
export class AddPersonComponent implements OnInit {

  newDelivery: DeliveryInputDto = {} as DeliveryInputDto;

  options = [
    { value: true, viewValue: 'Activa' },
    { value: false, viewValue: 'Desactivada' },
  ];

  addPersonForm: FormGroup = this.fb.group({
    nombre: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    comision: ['', Validators.compose([Validators.required,Validators.min(1)])],
    contrasena: ['', Validators.required],
    tel: ['',  Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    estado: ['', Validators.required],
    patente: ['',  Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    tarjetaC: ['',  Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    vencT: ['', Validators.required],
    licencia: ['',  Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    vencL: ['', Validators.required],
    
  })

  constructor(
    private fb: FormBuilder,
    public deliveryService: DeliveryService,
    private router: Router,
    private snackBar: SnackBarService
  ) {
  }

  ngOnInit() {
  }

  saveChanges(form: any) {
    this.newDelivery = {
      dsName: form.nombre,
      dsCirculation: form.tarjetaC,
      dsLicense: form.licencia,
      dsPassword: form.contrasena,
      dsPatent: form.patente,
      dsPhone: form.tel,
      dtCirculationExpiration: form.vencT,
      dtLicenseExpiration: form.vencL,
      isActive: form.estado,
      qtCommission: form.comision
    }
    this.deliveryService.apiDeliveryPostPost(this.newDelivery).subscribe(response => {
      this.router.navigate(['personal']);
      this.snackBar.openSnackBar('Los cambios se guardaron correctamente', 'Aceptar')
    }, error => {
      this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
    })
  }

}
